import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";

import CustomButton from "../Button";
import TextAreaEditor from "../TextAreaEditor";
import { API } from "../../utils/Apis";
import { showToast } from "../../utils/helpers";

interface ContentItemType {
  id: string;
  heading: string;
  content: string;
}

interface ContentItemFormType {
  type: "about" | "policy" | "health_and_safety";
  spaceId: string;
  show: boolean;
  onClose: Function;
  item?: ContentItemType | {} | undefined;
  updateItem: Function;
}

const ContentItemForm: React.FC<ContentItemFormType> = ({
  type,
  spaceId,
  show,
  onClose,
  item,
  updateItem,
}) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ContentItemType>({
    id: "",
    heading: "",
    content: "",
  });
  const [errors, setErrors] = useState({ heading: "", content: "" });

  const onChange = (field: string, value: string) => {
    setData({
      ...data,
      [field]: value,
    });
  };

  const validate = () => {
    let isError = false;
    const errors = { heading: "", content: "" };

    if (!data.heading || data.heading === "") {
      isError = true;
      errors.heading = "Please enter heading.";
    }

    if (!data.content || data.content === "") {
      isError = true;
      errors.content = "Please enter content.";
    }

    setErrors(errors);

    return isError;
  };

  const saveNewItem = () => {
    const isError = validate();
    console.log("DATA :", data);

    if (!isError && !loading) {
      setLoading(true);

      const tempData = {
        spaceId,
        type,
        heading: data.heading,
        content: data.content,
      };

      if (item && item.id) {
        // Update Item

        tempData.id = data.id;

        API.updateContentDetails(tempData)
          .then((res) => {
            if (res.type === "success") {
              updateItem(res.data);
            }

            showToast(res.type, res.message);
          })
          .catch((err) => {
            showToast("error", err.message);
          })
          .finally(() => setLoading(false));
      } else {
        // Create Item

        API.createContentDetails(tempData)
          .then((res) => {
            if (res.type === "success") {
              updateItem(res.data);
            }

            showToast(res.type, res.message);
          })
          .catch((err) => {
            showToast("error", err.message);
          })
          .finally(() => setLoading(false));
      }
    }
  };

  useEffect(() => {
    if (item && item.id) {
      setData({ ...item });
    }
  }, []);

  return (
    <Modal show={show} onHide={() => onClose()}>
      <Modal.Header closeButton>
        {item && item?.id ? "Update " : "Add "} Item
      </Modal.Header>
      <Modal.Body>
        <div className="form-group">
          <label>Heading</label>
          <input
            type="text"
            name="heading"
            className="form-control"
            placeholder=""
            value={data.heading}
            onChange={(e) => onChange("heading", e.target.value)}
          />

          {errors.heading && <span className="error">{errors.heading}</span>}
        </div>

        <div className="form-group">
          <label>Content</label>

          <TextAreaEditor
            value={data.content}
            onChange={(html: string) => onChange("content", html)}
          />

          {errors.content && <span className="error">{errors.content}</span>}
        </div>

        <div className="form-group">
          <CustomButton
            isLoading={loading}
            title="Save"
            onClick={() => saveNewItem()}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ContentItemForm;
